// 判断棋子可走的位置
let mark: any = {}
let role = ''
export const canGoRoad = (chess: string, x: number, y: number, transMap2: any[][]) => {
  const _chess = chess.toUpperCase()
  role = _chess === chess ? 'w' : 'b' // “w”表示红方，“b”表示黑方。
  mark = transMap2
  switch (chess.toUpperCase()) {
    case 'R': //车
      return rookRule(x, y)
    case 'C': //炮
      return rookRule(x, y)
    case 'N': //马
      return knight(x, y)
    case 'B': //象
      return bishopRule(x, y)
    case 'A': //士
      return guard(x, y)
    case 'K': //将帅
      return kingRule(x, y)
    case 'P': //兵
      return pawnRule(x, y)
    default:
      return []
  }
}
// 车
function rookRule(x: number, y: number) {
  let res: number[][] = []
  // 左检索
  for (let i = x - 1; i >= 0; i--) {
    if (mark[y][i] === null) res.push([i, y])
    else break
  }
  // 右检索
  for (let i = x + 1; i <= 8; i++) {
    if (mark[y][i] === null) res.push([i, y])
    else break
  }
  // 上检索
  for (let j = y - 1; j >= 0; j--) {
    if (mark[j][x] === null) res.push([x, j])
    else break
  }
  // 下检索
  for (let j = y + 1; j <= 9; j++) {
    if (mark[j][x] === null) res.push([x, j])
    else break
  }
  return res
}

// 马的行走规则
function knight(x: number, y: number) {
  let res: number[][] = []
  //1点
  if (y - 2 >= 0 && x + 1 <= 8 && !mark[y - 1][x] && mark[y - 2][x + 1] === null)
    res.push([x + 1, y - 2])
  //2点
  if (y - 1 >= 0 && x + 2 <= 8 && !mark[y][x + 1] && mark[y - 1][x + 2] === null)
    res.push([x + 2, y - 1])
  //4点
  if (y + 1 <= 9 && x + 2 <= 8 && !mark[y][x + 1] && mark[y + 1][x + 2] === null)
    res.push([x + 2, y + 1])
  //5点
  if (y + 2 <= 9 && x + 1 <= 8 && !mark[y + 1][x] && mark[y + 2][x + 1] === null)
    res.push([x + 1, y + 2])
  //7点
  if (y + 2 <= 9 && x - 1 >= 0 && !mark[y + 1][x] && mark[y + 2][x - 1] === null)
    res.push([x - 1, y + 2])
  //8点
  if (y + 1 <= 9 && x - 2 >= 0 && !mark[y][x - 1] && mark[y + 1][x - 2] === null)
    res.push([x - 2, y + 1])
  //10点
  if (y - 1 >= 0 && x - 2 >= 0 && !mark[y][x - 1] && mark[y - 1][x - 2] === null)
    res.push([x - 2, y - 1])
  //11点
  if (y - 2 >= 0 && x - 1 >= 0 && !mark[y - 1][x] && mark[y - 2][x - 1] === null)
    res.push([x - 1, y - 2])
  return res
}

// 象和相的行走规则
function bishopRule(x: number, y: number) {
  let res: number[][] = []
  if (role === 'w') {
    //红方
    //4点半
    if (y + 2 <= 9 && x + 2 <= 8 && !mark[y + 1][x + 1] && mark[y + 2][x + 2] === null)
      res.push([x + 2, y + 2])
    //7点半
    if (y + 2 <= 9 && x - 2 >= 0 && !mark[y + 1][x - 1] && mark[y + 2][x - 2] === null)
      res.push([x - 2, y + 2])
    //1点半
    if (y - 2 >= 5 && x + 2 <= 8 && !mark[y - 1][x + 1] && mark[y - 2][x + 2] === null)
      res.push([x + 2, y - 2])
    //10点半
    if (y - 2 >= 5 && x - 2 >= 0 && !mark[y - 1][x - 1] && mark[y - 2][x - 2] === null)
      res.push([x - 2, y - 2])
  } else {
    //4点半
    if (y + 2 <= 4 && x + 2 <= 8 && !mark[y + 1][x + 1] && mark[y + 2][x + 2] === null)
      res.push([x + 2, y + 2])
    //7点半
    if (y + 2 <= 4 && x - 2 >= 0 && !mark[y + 1][x - 1] && mark[y + 2][x - 2] === null)
      res.push([x - 2, y + 2])
    //1点半
    if (y - 2 >= 0 && x + 2 <= 8 && !mark[y - 1][x + 1] && mark[y - 2][x + 2] === null)
      res.push([x + 2, y - 2])
    //10点半
    if (y - 2 >= 0 && x - 2 >= 0 && !mark[y - 1][x - 1] && mark[y - 2][x - 2] === null)
      res.push([x - 2, y - 2])
  }
  return res
}

//士

const guard = (x: number, y: number) => {
  let res: number[][] = []
  if (role === 'w') {
    //红方
    //4点半
    if (y + 1 <= 9 && x + 1 <= 5 && mark[y + 1][x + 1] === null) res.push([x + 1, y + 1])
    //7点半
    if (y + 1 <= 9 && x - 1 >= 3 && mark[y + 1][x - 1] === null) res.push([x - 1, y + 1])
    //1点半
    if (y - 1 >= 7 && x + 1 <= 5 && mark[y - 1][x + 1] === null) res.push([x + 1, y - 1])
    //10点半
    if (y - 1 >= 7 && x - 1 >= 3 && mark[y - 1][x - 1] === null) res.push([x - 1, y - 1])
  } else {
    //4点半
    if (y + 1 <= 2 && x + 1 <= 5 && mark[y + 1][x + 1] === null) res.push([x + 1, y + 1])
    //7点半
    if (y + 1 <= 2 && x - 1 >= 3 && mark[y + 1][x - 1] === null) res.push([x - 1, y + 1])
    //1点半
    if (y - 1 >= 0 && x + 1 <= 5 && mark[y - 1][x + 1] === null) res.push([x + 1, y - 1])
    //10点半
    if (y - 1 >= 0 && x - 1 >= 3 && mark[y - 1][x - 1] === null) res.push([x - 1, y - 1])
  }
  return res
}

const kingRule = (x: number, y: number) => {
  let res: number[][] = []
  if (role === 'w') {
    //红方
    //下
    if (y + 1 <= 9 && mark[y + 1][x] === null) res.push([x, y + 1])
    //上
    if (y - 1 >= 7 && mark[y - 1][x] === null) res.push([x, y - 1])
  } else {
    //下
    if (y + 1 <= 2 && mark[y + 1][x] === null) res.push([x, y + 1])
    //上
    if (y - 1 >= 0 && mark[y - 1][x] === null) res.push([x, y - 1])
  }
  //右
  if (x + 1 <= 5 && mark[y][x + 1] === null) res.push([x + 1, y])
  //左
  if (x - 1 >= 3 && mark[y][x - 1] === null) res.push([x - 1, y])
  return res
}

const pawnRule = (x: number, y: number) => {
  let res: number[][] = []
  if (role === 'w') {
    //红方
    //上
    if (y - 1 >= 0 && mark[y - 1][x] === null) res.push([x, y - 1])
    //右
    if (x + 1 <= 8 && y <= 4 && mark[y][x + 1] === null) res.push([x + 1, y])
    //左
    if (x - 1 >= 0 && y <= 4 && mark[y][x - 1] === null) res.push([x - 1, y])
  } else {
    //下
    if (y + 1 <= 9 && mark[y + 1][x] === null) res.push([x, y + 1])
    //右
    if (x + 1 <= 8 && y >= 5 && mark[y][x + 1] === null) res.push([x + 1, y])
    //左
    if (x - 1 >= 0 && y >= 5 && mark[y][x - 1] === null) res.push([x - 1, y])
  }
  return res
}
